<template>
  <div style="text-align: left;">
    <el-row>
      <el-col :span="12">
        <h3>
          Prof. Sebastian Wachsmann-Hogiu 
        </h3>
        <h4>
        Department of Bioengineering 
        </h4>
        <h4>
        McConnell Engineering Building, Room 362 
        </h4>
        <h5>
         3480 Rue University, Montréal, QC H3A 0E9
        </h5>
      
        <h5>
        Université du Québec à Montréal Complexe des Sciences Pierre-Dansereau,Room 5585 
        </h5>

        <h4>
        Phone: 438-350 2897
        </h4>
        <h4>
        Email: sebastian.wachsmannhogiu@mcgill.ca
        </h4>
      </el-col>
      <el-col :span="12">
        <gmap-map
          :center="{lat:45.506078, lng:-73.576228}"
          :zoom="16"
          map-type-id="terrain"
          style="width: 500px; height: 300px"
        ></gmap-map>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import ElCol from "element-ui/packages/col/src/col";

  export default {
    components: {ElCol},
    data() {
      return {
        center: {lat: 10.0, lng: 10.0},
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
  };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/content/Contact.vue